import * as z from "zod";
import CompanyTypeEnum from "@/constants/enums/CompanyTypeEnum";

const companyTypeValues = Object.values(CompanyTypeEnum) as [string, ...string[]];

export const companyTypeSchema = z.enum(companyTypeValues, {
  errorMap: () => ({ message: "validation:companyTypeRequired" }),
});

export type CompanyType = z.infer<typeof companyTypeSchema>;
